import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronRight, FiHome } from 'react-icons/fi';

/**
 * Breadcrumb Component
 * Navigation trail showing current page location
 */
const Breadcrumb = ({ items = [], className = '' }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className={`py-4 ${className}`}
    >
      <ol className="flex items-center flex-wrap gap-2 text-sm">
        {/* Home link */}
        <li>
          <Link
            to="/"
            className="flex items-center gap-1 text-bukawa-gray-600 hover:text-bukawa-primary transition-colors"
          >
            <FiHome className="h-4 w-4" />
            <span>Home</span>
          </Link>
        </li>

        {/* Breadcrumb items */}
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <React.Fragment key={index}>
              {/* Separator */}
              <li>
                <FiChevronRight className="h-4 w-4 text-bukawa-gray-400" />
              </li>

              {/* Item */}
              <li>
                {isLast ? (
                  <span
                    className="text-bukawa-primary font-medium"
                    aria-current="page"
                  >
                    {item.label}
                  </span>
                ) : (
                  <Link
                    to={item.path}
                    className="text-bukawa-gray-600 hover:text-bukawa-primary transition-colors"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

/**
 * Page Header with Breadcrumb
 * Combines page title with breadcrumb navigation
 */
export const PageHeader = ({
  title,
  description,
  breadcrumbs = [],
  backgroundImage,
  className = '',
}) => {
  return (
    <div
      className={`
        relative bg-bukawa-primary py-12 lg:py-16
        ${backgroundImage ? 'bg-cover bg-center' : ''}
        ${className}
      `}
      style={
        backgroundImage
          ? { backgroundImage: `url(${backgroundImage})` }
          : undefined
      }
    >
      {/* Overlay */}
      {backgroundImage && (
        <div className="absolute inset-0 bg-bukawa-primary-900/80" />
      )}

      {/* Content */}
      <div className="container-custom relative z-10">
        {/* Breadcrumb */}
        {breadcrumbs.length > 0 && (
          <Breadcrumb
            items={breadcrumbs}
            className="mb-4 [&_a]:text-white/70 [&_a:hover]:text-white [&_span]:text-white"
          />
        )}

        {/* Title */}
        <h1 className="text-3xl lg:text-5xl font-heading font-bold text-white mb-4">
          {title}
        </h1>

        {/* Description */}
        {description && (
          <p className="text-lg text-white/90 max-w-3xl">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default Breadcrumb;